// ── RefundBadge ───────────────────────────────────────────────────────────────

interface RefundBadgeProps {
  amount: number | null | undefined;
  refundedAmount: number | null | undefined;
}

export function RefundBadge({ amount, refundedAmount }: RefundBadgeProps) {
  if (refundedAmount == null || refundedAmount <= 0) return null;

  const isFull = amount != null && refundedAmount >= amount;

  if (isFull) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-yellow-100 px-2 py-0.5 text-xs font-medium text-yellow-700">
        ↩ Full refund
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700">
      ↩ Partial refund
    </span>
  );
}
